(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["add-to-cart-button"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    // We luisteren naar clicks op de hele body om dynamisch ingeladen knoppen (via filters/pagination) op te vangen
    document.body.addEventListener('click', function(e) {
      const btn = e.target.closest('button.bis-collection-btn');
      if (btn) {
        e.preventDefault();
        e.stopPropagation(); // Voorkom dat the Vue/Custom component de ATC probeert uit te voeren
        
        // Open the Klaviyo Form
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'W2Syx5']);
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
